import React, { useState, useCallback, useEffect } from 'react'

import api from 'common/api'

import ModalPayCancelInfo from '../../components/modal/ModalPayCancelInfo'
import ModalPortal from '../../ModalPortal'
export default function ButtonPayCancelInfo({ orderNo, orderData, itemData }) {
  const [modalopen, setModalopen] = useState(false)
  const [cancelInfo, setCancelInfo] = useState(null) // 취소 정보를 저장할 state 추가

  // 취소 정보 모달열기
  const handleOpenModal = useCallback(() => {
    document.body.classList.add('modal-open')
    setModalopen(true)
  }, [])

  // 취소 정보 모달닫기
  const handleCloseModal = useCallback((e) => {
    document.body.classList.remove('modal-open')
    setModalopen(false)
  }, [])

  useEffect(() => {
    // 취소 정보 불러오기
    const getCancelInfo = async () => {
      try {
        // orderNo가 있는지 확인
        if (!orderNo) {
          console.log('orderNo is missing:', orderNo)
          return
        }

        console.log('Requesting cancel info for orderNo:', orderNo) // API 호출 전 orderNo 확인
        const response = await api.get(`/payment/v2/order/payment/cancel/${orderNo}`)
        console.log('API Response:', response) // 전체 응답 확인

        if (response.data.meta.code !== 200) {
          alert(response.data.meta.message)
        } else {
          setCancelInfo(response.data.data)
        }
      } catch (error) {
        console.error('API Error Details:', {
          status: error.response?.status,
          data: error.response?.data,
          message: error.message
        })
        console.error('주문 상세 정보를 불러오지 못했습니다.', error)
      }
    }

    if (modalopen) {
      // modalopen일 때만 API 호출
      getCancelInfo()
    }
  }, [modalopen, orderNo])

  return (
    <>
      <button className="button stroke btn-cancel-info" onClick={handleOpenModal}>
        <span>취소 정보</span>
      </button>

      {modalopen && (
        <ModalPortal>
          <ModalPayCancelInfo
            orderNo={orderNo}
            orderData={orderData}
            cancelInfo={cancelInfo}
            btnClose
            handleCloseModal={handleCloseModal}
          />
        </ModalPortal>
      )}
    </>
  )
}
